const handleOption = {
  id: 1,
  type: "handleStyle",
  label: "Touch Handle",
};

const handleOptionWindow = {
  id: 1,
  type: "handleStyle",
  label: "Surface Mount",
};

const handleColors = [
  "Matte Graphite Black",
  "Bronze Dark Anodized",
  "Natural Anodized",
];

const handleColorsBifoldAlum = ["Black", "Dark Silver"];

const surfaceMountColors = ["Black", "White", "Satin Chrome"];

export {
  handleOption,
  handleColors,
  handleColorsBifoldAlum,
  handleOptionWindow,
  surfaceMountColors,
};
